import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { Auth } from './auth';
import { User } from '@core/user/services/user';
import { environment } from '@env/environment';
import { isHubRequest } from './hub-fetch';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(Auth);
  const userService = inject(User);
  const generation = authService.sessionGeneration;

  const isApiRequest = isHubRequest(req.url);
  if (isApiRequest) {
    req = req.clone({
      withCredentials: true,
      setHeaders: {
        'X-Hub-Request': '1',
      },
    });
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Only the profile check can establish that this browser's session is
      // invalid. A 401 from another API call must not log the user out.
      if (
        error.status === 401 &&
        req.url === `${environment.apiUrl}/auth/profile/extended` &&
        authService.sessionGeneration === generation
      ) {
        // Clear token and user data
        authService.clearTokenCookie();
        authService.clearStoredUser();
        // Clear the User service signal
        userService.clearUser();
      }

      return throwError(() => error);
    }),
  );
};
